module.exports = __webpack_public_path__ + "img/Play.4431fbd1.svg";